import React,{useEffect,useRef,useState,useImperativeHandle,forwardRef} from 'react'
import ModalDa from '../Modal'
import {Form,Row,Col,Switch,Button, Input} from "antd"
import {useDispatch,useSelector} from 'react-redux'
import {FormItemLayoutType1} from '../../constants/Config'
import {NotificationManager} from 'react-notifications'
import {NotificationSuccessTimeOut} from '../../constants/Config'
import Password from '../PasswordComponents/Password'
import { userSignOut } from "../../appRedux/actions/Auth";
import { PutPassWord } from '../../appRedux/actions/UC/CompanyCreated'
import { NotificationContainer } from 'react-notifications';

const UpdatePassWord=forwardRef(({OnCancel,Visible},ref)=>{
    const dispatch = useDispatch()
    const [form]=Form.useForm()
    const [saved,setSaved]= useState(true)

    useImperativeHandle(ref,()=>({
        GetForm: form,
    }))
    
    const ButtonConfig={
        save:{
            disabled:saved,
            HandleClick:async ()=>{
                const password= await form.validateFields().then(resp=>resp).catch(()=>null);
                dispatch(PutPassWord(password, (data) => {
                    if (data===200){
                        //ver porque no me permite sacar este 
                        NotificationManager.success(`Se Actualizo Correctamente`,`Correcto!`,NotificationSuccessTimeOut);

                        setTimeout(() => {
                            dispatch(userSignOut())
                          }, 1000);
                        
                    }else{
                        NotificationManager.warning(`Hubo un Problema a la hora de modificar la contraseña`,`Aviso!`,NotificationSuccessTimeOut);
                    }
                }))
        }
        },
        cancel:{
            HandleClick:()=>{
                setSaved(true)
                form.resetFields()
                OnCancel()
            }
        }
    }
    
    return(
        <div>
        <ModalDa ButtonConfig={ButtonConfig}
                 Title={"Actualizar Contraseña"}
                 OnCancel={OnCancel} 
                 visible={Visible}
                 Width={500}>
          <Form {...FormItemLayoutType1}
                form={form}>
            <Col span={24}>
                        <Row>    

                         <Col lg={12} md={10} sm={12} xs={24}>
                         <Form.Item
                                name="password"
                                label="Contraseña"
                                rules={[
                                {
                                    required: true,
                                    message: 'Favor Ingresar Contraseña!',
                                },
                                ]}
                                hasFeedback
                            >
                                <Input.Password />
                            </Form.Item>
                         </Col>
                         
                         <Col lg={12} md={10} sm={12} xs={24}>
                                   <Form.Item
                            name="confirmationPassWord"
                            label="Confirmar Contraseña"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                            {
                                required: true,
                                message: 'Favor Ingresar Contraseña Nuevamente!',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    setSaved(false)
                                    return Promise.resolve();
                                }
                                setSaved(true)
                                return Promise.reject(new Error('Las Contraseña no coiciden!'));
                                },
                            }),
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                         </Col>
                    
                        </Row> 
            </Col>
            </Form>
            <NotificationContainer />
        </ModalDa>
        </div>
    )
})

UpdatePassWord.defaultProps={
    Visible:false,
    OnCancel:()=>{},
}


export default UpdatePassWord;

